/**
 * Alle witruimte tot één spatie, randen eraf.
 *
 * `\s` in JavaScript dekt ook de harde spatie (` `) en de CR van een `\r\n`, en dat is precies wat
 * je hier nodig hebt: de twee teksten zijn kopieën van elkaar, maar ze hebben verschillende velden
 * en verschillende formulieren gezien. Een `<textarea>` normaliseert regeleindes naar `\r\n`, een
 * geplakte tekst sleept harde spaties mee, en een trailing spatie ziet niemand.
 *
 * Dat kost "twee spaties is een verschil". Die wil je ook niet als verschil zien.
 */
function genormaliseerd(tekst: string): string {
  return tekst.replace(/\s+/g, " ").trim();
}

/**
 * Welke locatietekst het dienstscherm nog laat zien, naast de tekst van de opdracht.
 *
 * De planner schrijft zijn briefing op de locatie. De api kopieert die tekst één keer naar de
 * opdracht, op het moment dat de opdracht ontstaat, en daarna lopen de twee uit elkaar: wijzigt de
 * locatie, dan blijft de opdracht op de oude tekst staan. Daarom staat de locatietekst nu ook op
 * het dienstscherm.
 *
 * Bij een verse opdracht zijn ze alleen nog identiek, en dan zou dezelfde alinea er twee keer onder
 * elkaar staan. Vandaar deze regel: alleen tonen als hij iets toevoegt.
 *
 * Vergelijken op genormaliseerde witruimte, tonen doen we de tekst zoals hij geschreven is: de
 * regelval is de opmaak van een briefing, daar blijven we vanaf.
 */
export function venueBriefingToShow(
  projectDescription: string | null | undefined,
  venueDescription: string | null | undefined,
): string | null {
  const venue = venueDescription?.trim() ?? "";
  if (!venue) {
    return null;
  }

  const project = projectDescription ?? "";
  if (genormaliseerd(venue) === genormaliseerd(project)) {
    return null;
  }

  return venue;
}
